export default "__VITE_ASSET__DC3uzh1K__"